import { ToastService } from './../../../../../../base/services/toast.service';
import { SpinnerService } from './../../../../../../base/spinner/spinner.service';
import { Injectable } from "@angular/core";
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { ImportConfigurationClient, ImportSourceFieldDefinitionDTO, SampleFileDTO } from "src/app/base/models/models.swagger.generated";
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class FileColumnBasedService {
  constructor(private importConfigurationClient: ImportConfigurationClient, private spinnerService: SpinnerService, private toastService: ToastService) { }

  public getPossibleSourcesFromFile(sampleFile: SampleFileDTO): Observable<ImportSourceFieldDefinitionDTO[]> {
    this.spinnerService.show();
    return this.importConfigurationClient.getPossibleSourcesFromFile(sampleFile).pipe(
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError(err => {
        this.toastService.showError(
          'i18n.errors.server-error.title',
          'i18n.errors.server-error.message', null, ErrorType.serverError);
        return throwError(() => err);
      })
    );
  }

}